import { Checkbox, Divider, Row, Tooltip } from 'antd'
import { ScrollBar } from 'components/CommonStyles'
import ArrowSideIcon from 'components/icons/ArrowSideIcon'
import SearchInput from 'components/SearchInput'
import {
  CheckboxLabel,
  ColoContent,
  ColoItem,
  DepartColumn,
  MenuFlex,
  SubmitFlex,
} from 'modules/Courses/Partials/AddCourseDrawer/Style/style'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { EmptyElement } from '../../../../Events/EventRole/style'

const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox {
    display: none !important;
  }
`

export const DepartmentItem = styled.div`
  text-overflow: ellipsis;
  width: 270px;
  font-size: 16px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 3px;
  margin: 4px;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : ' #FAFAFB'};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '10px')};
  color: ${props => (props.color ? props.color : '#ffffff')};
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '600')};
  id: ${props => (props.id ? props.id : '')};
`
export const SideArrowItem = styled.div`
  width: 35px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : '#FAFAFB'};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '4px')};
  color: ${props => (props.color ? props.color : '#ffffff')};
  font-size: ${props => (props.fontSize ? props.fontSize : '16px')};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : '600')};
  pointer-events: ${props => (props.pointerEvents ? props.pointerEvents : '')};
`
const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  transform: translateX(4px); /* ← move arrow right */
`;


function DepartmentAndSpecialization({
  setCheckListCount,
  setSpecialisationCount,
  departmentList,
  setFinalOutput,
  departmentValue,
  specializationValue,
  setDepartmentName,
  setSpecializationName,
  carryParam,
  isEditing,
  depList,
  setDepList,
  checkedList,
  setCheckedList,
  setDepName,
  setSpecialisationList,
  addedSkill,
}) {
  const [dep, isDep] = useState(false)

  const [specValue, setSpecValue] = useState([])
  const [dValue, setDValue] = useState([])
  const [Specialization, setSpecialization] = useState(specializationValue)
  const [department, setDepartment] = useState([])
  const [hide, setHide] = useState(false)
  const [output, setOutput] = useState([])
  const [search, setSearch] = useState('')
  const [specSearch, setSpecSearch] = useState('')
  const [departmentId, setDepartmentId] = useState('')
  const [fOutput, setFOutput] = useState([])
  const [indeterminate, setIndeterminate] = useState(true)
  const [checkAll, setCheckAll] = useState(false)
  const [defaultSpecValue, setDefaultSpecValue] = useState([])
  const [clickedValueInDep, setClickedValueInDep] = useState('')
  const [mapId, setMapId] = useState([])
  const handleCheckboxChange = event => {
    const targetName = event?.target?.name
    const id = event?.target?.id
    const targetChecked = event?.target?.checked
    if (targetName === 'select-all') {
      let a = specValue?.[0]?.specialisation?.map(fruit => ({
        ...fruit,
        checked: targetChecked,
      }))
      let b = [{ id: specValue?.[0]?.id, specialisation: a }]
      const filteredArray = depList?.map(obj => {
        if (obj?.id === specValue?.[0]?.id) {
          return {
            ...obj,
            specialisation: obj?.specialisation?.map(specObj => {
              if (targetName === 'select-all') {
                return { ...specObj, checked: targetChecked }
              }

              return specObj
            }),
          }
        }
        return obj
      })
      setDepList(filteredArray)
      setSpecValue(b)
    } else {
      let a = specValue?.[0]?.specialisation?.map(fruit =>
        fruit?.id === id ? { ...fruit, checked: targetChecked } : fruit
      )

      let b = [{ id: specValue?.[0]?.id, specialisation: a }]
      setSpecValue(b)

      const filteredArray = depList?.map(obj => {
        if (obj?.id === specValue?.[0]?.id) {
          return {
            ...obj,
            specialisation: obj?.specialisation?.map(specObj => {
              if (specObj?.id === id) {
                return { ...specObj, checked: targetChecked }
              }
              return specObj
            }),
          }
        }
        return obj
      })
      setDepList(filteredArray)
    }
  }

  useEffect(() => {
    if (checkedList?.length == 0 || !checkedList) {
      let checkVal = depList?.map(item => {
        if (item?.id == departmentId) {
          return {
            ...item,
            specialisation: item?.specialisation?.map(fruit => ({
              ...fruit,
              checked: false,
            })),
          }
        } else {
          return item
        }
      })
      setDepList(checkVal)
      setDepartmentId('')
      setCheckAll(false)
      setSpecValue([])
    }
  }, [checkedList])
  const trueCheckboxes = Specialization?.filter(
    checkbox => checkbox?.checked === true
  )
  useEffect(() => {
    setSpecialisationCount(trueCheckboxes?.length)
    setOutput(Specialization)
    setFinalOutput(Specialization)
    const specialisationName = Specialization?.find(
      item => item?.checked == true
    )
    setSpecializationName(specialisationName?.name)
  }, [Specialization, trueCheckboxes])

  const onCheckAllChange = e => {
    let check = convertedArray?.map(item => item?.value)
    setDepartmentId('')
    setCheckedList(e?.target?.checked ? check : [])
    setIndeterminate(false)
    setCheckAll(e?.target?.checked)
    onChange(e?.target?.checked ? check : [])
    if (!e?.target?.checked) {
      setSpecialisationList([])
    }
  }
 
  useEffect(() => {
    setSpecialization(specializationValue)
  }, [specializationValue])
  useEffect(() => {
    let dList = departmentList?.map(item => {
      return {
        id: item?.id,
        name: item?.name,
        checked: item?.checked ? item?.checked : false,
        specialisation: item?.specialisation?.map(data => {
          return {
            ...data,
            checked: item?.checked ? item?.checked : false,
          }
        }),
      }
    })
    setDepList(dList)
  }, [departmentList, isEditing])
  useEffect(() => {
    if (Array.isArray(checkedList) && checkedList.length > 0 && checkedList.some(item => item)) {
      setCheckListCount(checkedList.filter(Boolean).length);
    } else {
      setCheckListCount(0);
    }
    if (departmentList?.length > 0) {
      let dpv = depList?.filter(item => {
        let filterdpv = checkedList?.includes(item?.id)
        return filterdpv
      })
      let depName = depList?.find(item => checkedList?.includes(item?.id))
      setDepName(depName?.name)
      let dep = dpv?.map(item => {
        return {
          id: item?.id,
          name: item?.name,
          checked: item?.checked ? item?.checked : false,
          specialisation: item?.specialisation?.map(data => {
            return {
              ...data,
              checked: item?.checked ? item?.checked : false,
            }
          }),
        }
      })
      setFOutput(dep)
    }
  }, [checkedList])

  useEffect(() => {
    if (dep) {
      let chec = checkedList
      let toRemove = clickedValueInDep
      let data = [clickedValueInDep]
      if (chec?.includes(toRemove)) {
        let removedData = chec?.filter(item => item !== clickedValueInDep)
        setCheckedList(removedData)
      } else {
        let cd = data

        let remainingData = [...new Set(chec?.concat(data))]
        let removedData = remainingData?.filter(item => item !== '')
        setCheckedList(removedData)
      }
      setClickedValueInDep('')
    }
  }, [clickedValueInDep, dep])
  useEffect(() => {
    let data = convertedArray?.map(item => item?.value)
    setCheckAll(JSON.stringify(department) === JSON.stringify(data))
  }, [department, convertedArray])

  const iconClicked = (event, value) => {
    setDepartmentId(value)
  }
  const clickedItem = value => {
    setClickedValueInDep(value)
  }

  const convertedArray = departmentList
    ?.filter(f => {
      if (search === '') {
        return true
      } else {
        return f?.name?.toLocaleLowerCase()?.includes(search?.toLowerCase())
      }
    })
    ?.map(item => {
      return {
        label: (
          <div
            style={{
              display: 'flex',
              gap: '10px',
              paddingTop: '10px',
            }}
            key={item?.id}
          >
            <div>
              <DepartmentItem
                backgroundColor={
                  checkedList?.includes(item?.id) ? '#3249D7' : ''
                }
                borderRadius={'10px'}
                color={checkedList?.includes(item?.id) ? '#FFFFFF' : '#999FAC'}
                fontSize={'16px'}
                fontWeight={'800'}
              >
                <Tooltip title={item?.name} placement="left">
                  <EmptyElement
                    customProp={item?.id}
                    onClick={e =>
                      clickedItem(e?.target?.getAttribute('customProp'))
                    }
                  >
                    {item?.name}
                  </EmptyElement>
                </Tooltip>
              </DepartmentItem>
            </div>
          </div>
        ),
        value: item?.id,
      }
    })

  const convertedArray1 = departmentList
    ?.filter(f => {
      if (search === '') {
        return true
      } else {
        return f?.name?.toLocaleLowerCase()?.includes(search?.toLowerCase())
      }
    })
    ?.map(item => {
      return {
        label: (
          <div
            style={{
              display: 'flex',
              gap: '10px',
              paddingTop: '11px',
            }}
            key={item?.id}
          >
            <div>
              <SideArrowItem
                backgroundColor={
                  checkedList?.includes(item?.id) && departmentId === item?.id
                    ? '#3249D7'
                    : '#EBECEE'
                }
                borderRadius={
                  checkedList?.includes(item?.id) && departmentId === item?.id
                    ? '10px'
                    : '12px'
                }
                color={
                  checkedList?.includes(item?.id) && departmentId === item?.id
                    ? '#FFFFFF'
                    : '#999FAC'
                }
                fontSize={'16px'}
                fontWeight={
                  checkedList?.includes(item?.id) && departmentId === item?.id
                    ? '500'
                    : '400'
                }
                pointerEvents={checkedList?.includes(item?.id) ? '' : 'none'}
              >
                <EmptyElement onClick={e => iconClicked(e, item?.id)}>
                  <ArrowIconWrapper>
                    <ArrowSideIcon />
                  </ArrowIconWrapper>
                </EmptyElement>
              </SideArrowItem>
            </div>
          </div>
        ),
        value: item?.id,
      }
    })

  useEffect(() => {
    if (departmentId) {
      let abc = depList?.filter(item => item?.id == departmentId)
      setSpecValue(abc)
    }
  }, [departmentId, depList])

  function merge_arrays(array1, array2) {
    const map = new Map(array1?.map(obj => [obj?.name, obj]))
    return array2?.map(obj => {
      const mergedObj = { ...obj }
      const existingObj = map?.get(obj?.name)
      if (existingObj) {
        mergedObj.checked = existingObj?.checked || mergedObj?.checked
      }
      return mergedObj
    })
  }

  const newOptions = departmentList
    ?.filter(f => {
      if (search === '') {
        return true // Include all items when there's no search term
      } else {
        return f?.name?.toLocaleLowerCase()?.includes(search?.toLowerCase())
      }
    })
    ?.map(item => item.id)
  const onChange = list => {
    if (
      (checkedList?.length >= 1 && list?.length !== checkedList?.length) ||
      (checkedList?.length >= 1 && list?.length == 1)
    ) {
      isDep(true)
    } else {
      isDep(false)
      // setCheckedList(list)
    }
    if (search) {
      const deselectedItem = checkedList?.find(item =>
        list.some(d => d === item)
      )
      if (deselectedItem) {
        const a = checkedList?.filter(item => !newOptions.some(d => item === d))
        setCheckedList([...(a || []), ...(list || [])])
      } else {
        if (list?.length === 0) {
          const a = checkedList?.filter(
            item => !newOptions.some(d => item === d)
          )
          setCheckedList([...(a || []), ...(list || [])])
        } else {
          setCheckedList([...(checkedList || []), ...(list || [])])
        }
      }
    } else {
      setCheckedList(list)
    }

    setDepartment(list)
    setIndeterminate(!!list?.length && list?.length < convertedArray?.length)
    setCheckAll(list?.length === convertedArray?.length)
    let SpecializationFilter = departmentList?.filter(item =>
      list?.includes(item?.id)
    )
    let depName = SpecializationFilter?.[0]?.name
    setDepartmentName(depName)
    let filterOptions = SpecializationFilter?.map(item => {
      return { id: item?.id, specialisation: item?.specialisation }
    })
    let toHide = filterOptions?.map(item => item?.specialisation)
    if (toHide && toHide?.length > 0) {
      setHide(false)
    } else {
      setHide(true)
    }

    const combinedArray = filterOptions?.map(item => {
      return {
        specialisation: item?.specialisation?.map(data => {
          return {
            ...data,
            checked: false,
            degreeStreamId: item?.id,
          }
        }),
      }
    })
    let a = combinedArray?.map(item => item?.specialisation)
    const combinedArray2 = a ? [].concat(...a) : []
    const mergedArray = merge_arrays(Specialization, combinedArray2)
    setSpecialization(mergedArray?.length > 0 ? mergedArray : combinedArray2)
  }

  const handleChange = e => {
    setSearch(e)
  }
  const handleSpecChanges = event => {
    setSpecSearch(event)
  }

  useEffect(() => {
    if (isEditing) {
      let specID = carryParam?.courseSpecialisationMap?.map(
        item => item?.specialisation
      )
      let id = specID?.map(item => item?.id)
      onChange([carryParam?.degreeStreamMapId])

      setDValue(departmentList)
      if (carryParam?.courseSpecialisationMap?.length > 0) {
        setDepartmentId(carryParam?.degreeStreamMapId)
      } else {
        setDepartmentId('')
      }
      setMapId(id)
      let idsToUpdate = id
      let updated_a = departmentList?.map(obj => ({
        id: obj?.id,
        name: obj?.name,
        checked: false,
        specialisation: obj?.specialisation?.map(sub_obj => ({
          id: sub_obj?.id,
          name: sub_obj?.name,
          checked: idsToUpdate?.includes(sub_obj?.id)
            ? true
            : sub_obj?.checked || false,
        })),
      }))
      setDepList(updated_a)
      setDefaultSpecValue(updated_a)
    }
  }, [isEditing, departmentList])

  return (
    <>
      <MenuFlex column>
        <Row>
          <ColoContent>Department</ColoContent>
          <Divider
            type="vertical"
            style={{
              height: '60px',
              border: '1px solid #E6E7EA',
            }}
          />

          <ColoContent>Specialization</ColoContent>
          <SubmitFlex style={{ width: '100%' }} />
        </Row>
        <Row>
          <ScrollBar
            id="scrollableDiv"
            height={'40vh'}
            overFlowX="hidden"
            style={{ width: '46%' }}
          >
            <ColoItem>
              <>
                <div style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                  <SearchInput
                    width={'90%'}
                    placeholder="Search by keyword"
                    bordered={true}
                    setSearchValue={handleChange}
                  />
                </div>
                <Checkbox
                  style={{ paddingLeft: '10px', paddingTop: '10px' }}
                  indeterminate={indeterminate}
                  onChange={onCheckAllChange}
                  checked={checkAll}
                >
                  Select All
                </Checkbox>
                <div style={{ display: 'flex', gap: '5%', paddingTop: '10px' }}>
                  <div style={{ width: '70%' }}>
                    <StyledCheckboxGroup
                      options={convertedArray}
                      value={checkedList || departmentValue}
                      defaultValue={departmentValue}
                      onChange={onChange}
                    />
                  </div>
                  <div style={{ width: '15%' }}>
                    <StyledCheckboxGroup options={convertedArray1} />
                  </div>
                </div>
              </>
            </ColoItem>
          </ScrollBar>
          <Divider
            type="vertical"
            style={{
              height: '380px',
              border: '1px solid #E6E7EA',
            }}
          />

          <ScrollBar
            id="scrollableDiv"
            height={'40vh'}
            style={{ width: '50%' }}
          >
            {specValue?.[0]?.specialisation?.length > 0 ? (
              <ColoItem>
                <DepartColumn>
                  <div>
                    <SearchInput
                      width={'90%'}
                      placeholder="Search by keyword"
                      bordered={true}
                      setSearchValue={handleSpecChanges}
                    />
                  </div>
                  <CheckboxLabel>
                    <input
                      type="checkbox"
                      name="select-all"
                      checked={specValue?.[0]?.specialisation?.every(
                        fruit => fruit?.checked
                      )}
                      onChange={handleCheckboxChange}
                      style={{
                        width: '15px',
                        outline: 'unset',
                        outlineOffset: 'unset',
                      }}
                    />
                    Select All
                  </CheckboxLabel>
                  {specValue?.[0]?.specialisation
                    ?.filter(v => {
                      if (specSearch === '') {
                        return true
                      } else {
                        return v?.name
                          ?.toLocaleLowerCase()
                          ?.includes(specSearch?.toLowerCase())
                      }
                    })
                    ?.map(fruit => (
                      <CheckboxLabel key={fruit?.name} id={fruit?.id}>
                        <input
                          style={{
                            width: '15px',
                            outline: 'unset',
                            outlineOffset: 'unset',
                          }}
                          type="checkbox"
                          name={fruit?.name}
                          id={fruit?.id}
                          checked={fruit?.checked}
                          onChange={handleCheckboxChange}
                        />
                        {fruit?.name}
                      </CheckboxLabel>
                    ))}
                </DepartColumn>
              </ColoItem>
            ) : (
              <>
                <div style={{ margin: '50px' }}>
                  There is no Specialization in the department...
                </div>
              </>
            )}
          </ScrollBar>
        </Row>
      </MenuFlex>
    </>
  )
}
export default DepartmentAndSpecialization
